import { Expose } from "class-transformer";
import { CreateDeliveryNoteLineDto } from "@/core/features/delivery-notes/create-delivery-note-line.dto";

export class UpdateDeliveryNoteLineDto extends CreateDeliveryNoteLineDto {
  @Expose()
  id?: string;
}
